/**
 * Global Angular Material Density Configuration
 * This file provides compact/high-density settings for all Material components
 */

import { Provider } from '@angular/core';
import {
    MAT_FORM_FIELD_DEFAULT_OPTIONS,
    MatFormFieldDefaultOptions,
} from '@angular/material/form-field';
import {
    MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS,
    MatButtonToggleDefaultOptions,
} from '@angular/material/button-toggle';
import {
    MAT_CHECKBOX_DEFAULT_OPTIONS,
    MatCheckboxDefaultOptions,
} from '@angular/material/checkbox';
import {
    MAT_RADIO_DEFAULT_OPTIONS,
    MatRadioDefaultOptions,
} from '@angular/material/radio';
import {
    MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS,
    MatSlideToggleDefaultOptions,
} from '@angular/material/slide-toggle';
import { MAT_TABS_CONFIG, MatTabsConfig } from '@angular/material/tabs';

/**
 * Form Field - Compact Appearance
 */
const formFieldOptions: MatFormFieldDefaultOptions = {
    appearance: 'outline',
    floatLabel: 'auto',
    subscriptSizing: 'dynamic',
};

/**
 * Button Toggle - Compact
 */
const buttonToggleOptions: MatButtonToggleDefaultOptions = {
    hideSingleSelectionIndicator: true,
    hideMultipleSelectionIndicator: true,
};

/**
 * Checkbox - Compact
 */
const checkboxOptions: MatCheckboxDefaultOptions = {
    color: 'primary',
};

/**
 * Radio - Compact
 */
const radioOptions: MatRadioDefaultOptions = {
    color: 'primary',
};

/**
 * Slide Toggle - Compact
 */
const slideToggleOptions: MatSlideToggleDefaultOptions = {
    color: 'primary',
    hideIcon: false,
};

/**
 * Tabs - Compact
 */
const tabsConfig: MatTabsConfig = {
    fitInkBarToContent: true,
    stretchTabs: false,
};

/**
 * Export all Material Density providers
 */
export const MATERIAL_DENSITY_PROVIDERS: Provider[] = [
    {
        provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
        useValue: formFieldOptions,
    },
    {
        provide: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS,
        useValue: buttonToggleOptions,
    },
    {
        provide: MAT_CHECKBOX_DEFAULT_OPTIONS,
        useValue: checkboxOptions,
    },
    {
        provide: MAT_RADIO_DEFAULT_OPTIONS,
        useValue: radioOptions,
    },
    {
        provide: MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS,
        useValue: slideToggleOptions,
    },
    {
        provide: MAT_TABS_CONFIG,
        useValue: tabsConfig,
    },
];
